import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import {
  HelperService,
  AppSettings,
  AuthenticationService,
  Getunitdetails,
  Agents,
} from '../../../services/_services';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import Swal from 'sweetalert2';

declare var document, $;

@Component({
  selector: 'app-order-classification',
  templateUrl: './order-classification.component.html',
  styleUrls: ['./order-classification.component.css'],
})
export class OrderClassificationComponent implements OnInit {
  public orderStatus: any = AppSettings.orderStatus;
  public documentTypeArray: any = AppSettings.documentType;
  public loading: any = false;
  public paginatePage: any;
  public leads: any = [];
  public otherStats: any = [];
  public classes: any = [
    { name: 'Subject', value: 'subject' },
    { name: 'Work Type', value: 'work_type' },
  ];
  public comments: any = [];
  public agentComments: any = [];
  public qaComments: any = [];
  public agents: any;
  public qa: any;
  public loader: any;
  public qaLoader: any;
  public checkedClass: any = false;
  public qaRating: any;
  public activeUser: any;

  @ViewChild(DataTableDirective)
  public dtElement: DataTableDirective;
  public dtOptions: DataTables.Settings = {};
  public dtTrigger: any = new Subject();

  public searchParams: any = {
    date_from: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
    date_to: new Date(),
    class: this.classes[0],
  };
  public fullRangeDate: any = [
    this.searchParams.date_from,
    this.searchParams.date_to,
  ];

  public agentsSub: any;

  constructor(
    private helperService: HelperService,
    private agentsService: Agents,
    private authenticationService: AuthenticationService,
    private cdr: ChangeDetectorRef
  ) {
    this.activeUser = this.authenticationService.get_currentUserValue();

    // Get Agents
    this.agentsSub = this.agentsService.agentsS$.subscribe((agents) => {
      if (agents) {
        this.agents = agents.agents;
        this.qa = agents.qa;
      }
    });

    this.dtOptions = {
      paging: true,
      info: true,
      // ordering: false,
      pagingType: 'full_numbers',
      pageLength: 50,
      serverSide: true,
      processing: true,
      searching: false,
      language: AppSettings.dataTableLang,
      columnDefs: [
        { orderable: false, targets: 0 },
        { orderable: false, targets: 1 },
        { orderable: true, targets: 2 },
      ],
      order: [[2, 'desc']],
      ajax: (dataTablesParameters: any, callback) => {
        // Show Loader
        this.loading = true;

        let url = AppSettings.API_ENDPOINT + 'admin/get-classified-oder-stats';

        let dtParams = {
          date_from: this.searchParams.date_from
            ? this.helperService.caonvertDateToString(
                this.searchParams.date_from
              )
            : this.fullRangeDate
            ? this.helperService.caonvertDateToString(this.fullRangeDate[0])
            : '',
          date_to: this.searchParams.date_to
            ? this.helperService.caonvertDateToString(
                this.searchParams.date_to,
                false
              )
            : this.fullRangeDate
            ? this.helperService.caonvertDateToString(
                this.fullRangeDate[1],
                false
              )
            : '',
          class: this.searchParams.class.value,
          start: dataTablesParameters.start,
          length: dataTablesParameters.length,
          order: dataTablesParameters.order,
          columns: dataTablesParameters.columns,
        };

        // For Record Serial Numbers
        this.paginatePage = dataTablesParameters.start;
        this.leads.data = [];

        this.helperService
          .httpPostRequestsDecryp(url, dtParams)
          .then((resp) => {
            this.leads = JSON.parse(resp);
            this.otherStats = this.leads.otherStats;
            // console.log("this.leads", this.leads);

            // Set Default page len
            this.dtOptions.pageLength = this.dtElement['dt'].page.len();

            // Hide Loader
            this.loading = false;

            callback({
              recordsTotal: this.leads.total,
              recordsFiltered: this.leads.total,
              // recordsFiltered: resp['recordsFiltered'],
              // recordsFiltered: 1000,
              data: [],
            });

            // // $(".paginate_button .current").css("color", "white");
            // // console.log('$(".paginate_button .current"): ',$(".paginate_button .current"))
            $('div.dataTables_length select').addClass('dt-form-control');
            $('div.dataTables_filter input').addClass('dt-form-control');
          })
          .catch((error) => {
            // Set loader false
            this.loading = false;

            // // Rerender DT in case of failure
            // this.rerender();

            console.log('error: ', error);
          });
      },
      columns: [{ data: 'Sr' }, { data: 'subject' }, { data: 'count' }],
      // Use this attribute to enable the responsive extension
      responsive: false,
    };
  }

  ngOnInit() {}

  ngAfterViewInit() {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();

    if (typeof this.agentsSub != 'undefined') {
      //prevent memory leak when component destroyed
      this.agentsSub.unsubscribe();
    }
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();

      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

  splitFromTo() {
    console.log('-- this.fullRangeDate:: ', this.fullRangeDate);
    if (this.fullRangeDate) {
      this.searchParams.date_from = this.fullRangeDate[0];
      this.searchParams.date_to = this.fullRangeDate[1];
    }
    this.rerender();
  }

  clearFilters() {
    this.searchParams = {
      date_from: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
      date_to: new Date(),
      class: this.classes[0],
    };
    this.fullRangeDate = [
      this.searchParams.date_from,
      this.searchParams.date_to,
    ];

    this.rerender();
  }
}
